import React from "react";

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const ToggleButton = ({ checked, onChange, disabled = false }: Props) => {
  return (
    <label className="inline-flex relative items-center cursor-pointer">
      <input
        type="checkbox"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        className="sr-only peer"
        checked={checked}
        onChange={() => onChange(!checked)}
      />

      {/* Track */}
      <div
        className={`
          w-11 h-6 rounded-full
          transition-colors duration-300
          ${checked ? "bg-sky-600" : "bg-gray-200"}
          ${disabled ? "opacity-50 cursor-not-allowed" : ""}
        `}
      >
        {/* Thumb */}
        <div
          className={`
            absolute top-0.5 left-[2px] h-5 w-5 bg-white border border-gray-300 rounded-full
            transition-transform duration-300
            ${checked ? "translate-x-full border-white" : ""}
          `}
        />
      </div>
    </label>
  );
};

export default ToggleButton;
